import { ReactElement } from "react";
import "../../css/TeeStyles.css";
import { Services, servicesData } from "../smallComponents/listIconText";

interface interfaceObject {
  id: number | string;
  image: string;
  heading: string;
  subHeading: string;
  body: string;
}

const serviceObject: interfaceObject[] = servicesData.map((service, id) => ({
  id: id,
  image: service.image,
  heading: service.heading,
  subHeading: service.subHeading,
  body: service.body,
}));

const SectionTwo = (): ReactElement => {
  return (
    <div className="pt-5 about-bg">
      <span className="d-block wid50 wid100Mobile mx-auto mb-4 text-center fontSize36px white boldSeven half-border-center">
        WHAT WE OFFER
      </span>
      <div className="wid80 wid50Mobile mx-auto">
        <Services servicesData={serviceObject} />
      </div>
      <div className="wid80 wid50Mobile mx-auto pb-5">
        <div className="marginTopSmallNavLong section blackKsb wid100 mx-auto my-image-about-1 px-md-4 px-2">
          <div>
            <span className="d-block mx-auto text-center boldSeven fontSize32px pt-6 white">
              CREATE WITH US
            </span>
            <span className="d-block mx-auto text-center fontSize48px boldSeven pt-3 pb-5 white">
              We bring your ideas to life with precision and style.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionTwo;
